export default {
  ComponentManageList: () => import('@/views/componentManage/listPage/ComponentManageList'),
}